document.addEventListener('DOMContentLoaded', () => {
  const GORGIAS_CONTAINER_ID = 'gorgias-chat-container';
  const initPromise = window.GorgiasChat
    ? GorgiasChat.init()
    : new Promise(resolve => window.addEventListener('gorgias-widget-loaded', resolve));

  function addPageClassToGorgiasContainer() {
    const container = document.getElementById(GORGIAS_CONTAINER_ID);
    if (!container) return;

    const pageClass = Array.from(document.body.classList)
      .find(c => c.endsWith('-template'))
      ?.replace(/-template$/, '');
    const newClass = pageClass ? `gorgias-chat-page-${pageClass}` : 'gorgias-chat-page-default';

    container.classList.add(newClass);
  }

  addPageClassToGorgiasContainer();
  initPromise.then(() => addPageClassToGorgiasContainer());

  const gorgiasObserver = new MutationObserver(() => {
    if (document.getElementById(GORGIAS_CONTAINER_ID)) {
      addPageClassToGorgiasContainer();
      gorgiasObserver.disconnect();
    }
  });
  gorgiasObserver.observe(document.body, { childList: true, subtree: true });
});
